import React, { type JSX } from 'react';
import { Autocomplete, Chip, TextField, IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export const AutoCompleteTags = (props: any): JSX.Element => {
    const isMaxLimit = props?.value?.length === (props?.maxValue ?? 6);

    const handleClearAll = (e: React.MouseEvent): void => {
        e.preventDefault();
        e.stopPropagation();
        if (typeof props?.onChange === 'function') {
            props?.onChange(null, []);
        }
    };

    return (
        <Autocomplete
            multiple
            id="tagIds"
            data-testid="tags-autocomplete"
            value={props?.value}
            disabled={props?.disabled}
            {...(props?.options?.every((item: any) => typeof item === 'object') && {
                getOptionLabel: (option: any) => option.name,
            })}
            options={props?.options}
            onChange={props?.onChange}
            renderTags={(value: any[], getTagProps): any =>
                value.map((option: any, index: number) => (
                    // eslint-disable-next-line react/jsx-key
                    <Chip
                        {...getTagProps({ index })}
                        data-testid={`tag-chip-${index}`}
                        label={typeof option === 'object' ? option?.name : option}
                        onDelete={(): void =>
                            props?.handleTagDelete(typeof option === 'object' ? option?.id : option, index)
                        }
                    />
                ))
            }
            renderInput={(params): JSX.Element => (
                <TextField
                    error={props?.error}
                    className={props?.className}
                    {...params}
                    variant="filled"
                    hiddenLabel
                    id="name"
                    data-testid="tags-input"
                    {...(!isMaxLimit && { placeholder: props.placeholder })}
                    onKeyDown={props?.onKeyDown}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {props.isClearAll && isMaxLimit && props?.value?.length > 0 && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onMouseDown={(e) => e.stopPropagation()}
                                            onClick={handleClearAll}
                                            data-testid="tags-clear-all-btn"
                                            sx={{
                                                padding: '4px',
                                                marginRight: '4px',
                                                color: '#6e6e6e',
                                                backgroundColor: 'transparent',
                                                '&:hover': {
                                                    backgroundColor: 'transparent',
                                                    color: '#333',
                                                },
                                                '& svg': {
                                                    width: 20,
                                                    height: 20,
                                                },
                                            }}
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    inputProps={{
                        ...params.inputProps,
                        maxLength: 16,
                    }}
                />
            )}
            readOnly={isMaxLimit}
        />
    );
};
